export const NEXT_PUBLIC_GA_ID = process.env.NEXT_PUBLIC_GA_ID

declare global {
  interface Window {
    gtag?: any;
  }
}

// https://developers.google.com/analytics/devguides/collection/gtagjs/pages
export const pageview = (url: any) => {
  window.gtag('config', NEXT_PUBLIC_GA_ID, {
    page_path: url,
  })
}

// https://developers.google.com/analytics/devguides/collection/gtagjs/events
export function event({ action, category, label, value } : any): void {
  window.gtag('event', action, {
    event_category: category,
    event_label: label,
    value: value,
  })
}
